


































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import ContactForm from "./ContactForm.vue";
import { Type } from "../models/message";
import { InsertMessage } from "../models/insert-message";
import { postMessage } from "../api";
import { SnackbarInterface } from "shared/store/snackbar/state";

const store = namespace("contact");
const snackStore = namespace("snackbar");

@Component({
  components: { ContactForm }
})
export default class ContactDialog extends Vue {
  @store.State visible!: boolean;
  @store.State type!: Type | "";
  @store.Mutation close!: () => void;
  @snackStore.Mutation setSnackbar!: (payload: SnackbarInterface) => void;

  private message: InsertMessage | null = null;

  private async send(): Promise<void> {
    if (this.message === null) return;
    try {
      await postMessage(this.message);
      this.setSnackbar({
        text: this.$t("contact.alerts.success").toString(),
        color: "success"
      });
    } catch (e) {
      this.setSnackbar({
        text: this.$t("contact.alerts.error").toString(),
        color: "error"
      });
      return;
    }
    this.close();
  }
}
